'use strict';
'use es6';

/**
 * @deprecated - this file will be removed in the next major version
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('./index');

var all = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = all;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.33/js/utils.js
// module id = 104
// module chunks = 0